import React, { useState, useEffect } from 'react'
import './FAQ_Tabs.css'
import { Accordion, Button, Nav, Tab } from 'react-bootstrap'
import { getFaq, getSubfaq } from '../../../features/faq/Slice';
import { useDispatch, useSelector } from "react-redux";

const FAQ_Tabs = () => {
    const faq = useSelector((state) => state.faq.addFaq);
    const subfaq = useSelector((state) => state.faq.addSubfaqById);
    const dispatch = useDispatch();
  


    const [activeTab, setActiveTab] = useState(null); 
   

   useEffect(() => {
         dispatch(getFaq());
       }, [dispatch]);

       const handleTabClick = (id) => {
        setActiveTab(id);
        dispatch(getSubfaq(id)); // Fetch subFAQs when a tab is clicked
    };
    

    // const [activeTab, setActiveTab] = useState("GENERAL"); 

    return (
        <section className='FAQ_Tabs'>
            <Tab.Container
                id="left-tabs-example"
                className="faq_tabs_container"
                activeKey={activeTab} 
                onSelect={(key) => handleTabClick(key)} 
            >
                <div>
                    <div className="col-md-6 col-sm-12 col-12">
                        <Nav variant="pills"  className="all_tabs_holder" fill>
                            {faq?.data?.map((val)=>
                           ( <Nav.Item className='tab_holder' key={val?.id}>
                                <Nav.Link 
                                eventKey={val?.id}
                                className="tab_btn"
                                onClick={() => handleTabClick(val?.id)}
                                    >
                                   {val?.name}
                                 
                                </Nav.Link>
                            </Nav.Item>
                        ))}

                        </Nav>
                    </div>
                    <div>
                        <Tab.Content>
                      
                                <Tab.Pane eventKey={activeTab} >
                                    <Accordion defaultActiveKey="0">
                                        {subfaq?.data?.length > 0 ? (
                                            subfaq?.data?.map((val) => (
                                                <Accordion.Item eventKey={val?.id} key={val?.id}>
                                                    <Accordion.Header>
                                                        <p className="question_text">{val?.question}</p>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <p className='faq_answer_text'>{val?.answers}</p>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            ))
                                        ) : (
                                            <p>No FAQs available for this category.</p>
                                        )}
                                    </Accordion>
                                </Tab.Pane>
                           

                            {/* <Tab.Pane eventKey="PAYMENT">
                                
                            <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header><p className="question_text">What Shipping Methods Are Available?</p></Accordion.Header>
                                        <Accordion.Body>
                                            <div className='answer_div'>

                                                <p className='faq_answer_text'>
                                                    <b>1. Standard Ground Shipping:</b>
                                                    This is usually the most economical option and typically takes between 3 to 7 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b> 2. Express Shipping:</b>
                                                    Faster than standard shipping, often delivering within 2 to 3 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b>3. Overnight Shipping:</b>
                                                    The fastest option, delivering the next business day.
                                                </p>

                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header><p className="question_text">How Do I Track My Order?</p></Accordion.Header>
                                        <Accordion.Body>
                                            <div className='answer_div'>

                                                <p className='faq_answer_text'>
                                                    <b>1. Standard Ground Shipping:</b>
                                                    This is usually the most economical option and typically takes between 3 to 7 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b> 2. Express Shipping:</b>
                                                    Faster than standard shipping, often delivering within 2 to 3 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b>3. Overnight Shipping:</b>
                                                    The fastest option, delivering the next business day.
                                                </p>

                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header><p className="question_text">Do You Allow To Exchange?</p></Accordion.Header>
                                        <Accordion.Body>
                                            <div className='answer_div'>

                                                <p className='faq_answer_text'>
                                                    <b>1. Standard Ground Shipping:</b>
                                                    This is usually the most economical option and typically takes between 3 to 7 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b> 2. Express Shipping:</b>
                                                    Faster than standard shipping, often delivering within 2 to 3 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b>3. Overnight Shipping:</b>
                                                    The fastest option, delivering the next business day.
                                                </p>

                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>

                            </Tab.Pane>

                            <Tab.Pane eventKey="ONLINE">
                                
                            <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header><p className="question_text">What Shipping Methods Are Available?</p></Accordion.Header>
                                        <Accordion.Body>
                                            <div className='answer_div'>

                                                <p className='faq_answer_text'>
                                                    <b>1. Standard Ground Shipping:</b>
                                                    This is usually the most economical option and typically takes between 3 to 7 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b> 2. Express Shipping:</b>
                                                    Faster than standard shipping, often delivering within 2 to 3 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b>3. Overnight Shipping:</b>
                                                    The fastest option, delivering the next business day.
                                                </p>

                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header><p className="question_text">How Do I Track My Order?</p></Accordion.Header>
                                        <Accordion.Body>
                                            <div className='answer_div'>

                                                <p className='faq_answer_text'>
                                                    <b>1. Standard Ground Shipping:</b>
                                                    This is usually the most economical option and typically takes between 3 to 7 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b> 2. Express Shipping:</b>
                                                    Faster than standard shipping, often delivering within 2 to 3 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b>3. Overnight Shipping:</b>
                                                    The fastest option, delivering the next business day.
                                                </p>

                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header><p className="question_text">Do You Allow To Exchange?</p></Accordion.Header>
                                        <Accordion.Body>
                                            <div className='answer_div'>

                                                <p className='faq_answer_text'>
                                                    <b>1. Standard Ground Shipping:</b>
                                                    This is usually the most economical option and typically takes between 3 to 7 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b> 2. Express Shipping:</b>
                                                    Faster than standard shipping, often delivering within 2 to 3 business days.
                                                </p>

                                                <p className='faq_answer_text'>
                                                    <b>3. Overnight Shipping:</b>
                                                    The fastest option, delivering the next business day.
                                                </p>

                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>

                                </Accordion>

                            </Tab.Pane> */}
                        </Tab.Content>
                    </div>
                </div>
            </Tab.Container>
        </section>
    )
}

export default FAQ_Tabs
